import React from 'react'
import { compact } from 'lodash'

import CalendarEventChip from './CalendarEventChip'

import css from './style.scss'

export const MAX_CHIPS_PER_DAY = 2

/**
 * One day of the month grid. Overflow expands in place rather than in a
 * popover: React 15 has no portal, and positioning one inside the
 * `display: table` page layout is not worth the trouble.
 */
const CalendarDayCell = ({ day, events, expanded, onToggle }) => {
  const listId = `calendar-day-${day.date.format('YYYY-MM-DD')}`
  const hidden = Math.max(0, events.length - MAX_CHIPS_PER_DAY)
  const visible = expanded ? events : events.slice(0, MAX_CHIPS_PER_DAY)

  return (
    <td
      className={compact([
        css.dayCell,
        day.inMonth ? null : css.dayCellOutside,
        day.isToday ? css.dayCellToday : null
      ]).join(' ')}
      aria-current={day.isToday ? 'date' : null}
    >
      <time className={css.dayNumber} dateTime={day.date.format('YYYY-MM-DD')}>
        {day.date.format('D')}
      </time>

      {events.length > 0 && (
        <ul className={css.chipList} id={listId}>
          {visible.map(event => (
            <CalendarEventChip key={`${event.type}-${event.id}`} event={event} />
          ))}
        </ul>
      )}

      {hidden > 0 && (
        <button
          type='button'
          className={css.moreButton}
          aria-expanded={expanded}
          aria-controls={listId}
          onClick={() => onToggle(day.date)}
        >
          {expanded ? 'Show less' : `+${hidden} more`}
        </button>
      )}
    </td>
  )
}

CalendarDayCell.propTypes = {
  day: React.PropTypes.shape({
    date: React.PropTypes.object.isRequired,
    inMonth: React.PropTypes.bool,
    isToday: React.PropTypes.bool
  }).isRequired,
  events: React.PropTypes.array.isRequired,
  expanded: React.PropTypes.bool,
  onToggle: React.PropTypes.func.isRequired
}

CalendarDayCell.defaultProps = {
  expanded: false
}

export default CalendarDayCell
